<template>
  <!-- 导航栏 -->
  <div class="headerNavClass">
    <!-- @mouseenter="editColor('en')"
    @mouseleave="editColor('le')"-->
    <div class="tittle flex navContentClass tittle_other" id="topNav">
      <!-- :class="napColorShow ? 'tittle_other' : 'tittle_other_2'" -->
      <div class="logo fl" style="margin-left: 35px">
        <img
          v-if="ifTop"
          ref="titleRef"
          :src="napColorShow
          ? require('../../assets/whiteLogo.png')
          : require('../../assets/publicService/logo.png')
          "
          alt
          @click="getHome"
        />
        <img v-else src="../../assets/publicService/logob.png" @click="getHome" />
        <!-- <h5>3D打印工业互联网平台</h5> -->
      </div>
      <div class="mapName flex">
        <div class="flex tittle_ul">
          <li
            v-for="(items, index) in maplist"
            :key="index"
            @mouseenter="solutionMouseOver(items.name, items.children)"
            @click="mapNameList(items.path, items.children, items.name)"
            :ref="'navItemRef' + items.value"
            :class="mapLi == items.name ? 'mapNameLi' : ''"
          >
            <mapMesgList v-if="items.children != null" :mesgObj="items"></mapMesgList>
            <span v-else class="changeColor">{{ items.name }}</span>
          </li>
        </div>
      </div>
      <solutionNavigation
        ref="solutionNavigationRef"
        @closeSolutionNavigation="closeSolutionNavigation"
      ></solutionNavigation>
      <!-- 搜索 -->
      <div class="flex right_box userInfo">
        <!-- 搜索框和列表 -->
        <div class="top-search" :style="{border:(ifTop ? '' : '1px solid #2d50a1')}">
          <el-input
            placeholder="请输入关键字"
            v-model="searchText"
            clearable
            @keyup.native.enter="overRallQuery"
            ref="allSearch"
          >
            <template slot="prepend">
              <el-select v-model="selectType" placeholder="请选择" popper-class="all_select_popper">
                <el-option
                  :label="item.label"
                  :value="item.value"
                  v-for="(item,index) in searchTypeList"
                  :key="index"
                  style="z-index:99999"
                ></el-option>
              </el-select>
            </template>
            <template slot="append">
              <div class="top-search-icon" @click="overRallQuery"></div>
            </template>
          </el-input>
          <!-- <div class="top-search-list" :class="ifTop ? '' : 'search-list-black'"></div> -->
        </div>
        <div
          class="login flex loginText"
          v-if="isLogin"
          :class="!napColorShow ? 'loginTextFFF' : ''"
        >
          <!-- <p @click="handleDocument">文档</p> -->
          <p @mouseenter="showTimesMessage" @mouseleave="falseTimesMessage" id="staging1">工作台</p>
          <p
            class="userName"
            @click="handleUesermess"
            ref="userName"
            id="user"
          >HI,{{ $store.state.isUsermessage.name }}</p>
        </div>
        <div class="login flex loginText" v-else :class="!napColorShow ? 'loginTextFFF' : ''">
          <!-- <p @click="handleDocument">文档</p> -->
          <p @click="getRegisteredLogin(2)" id="staging2">工作台</p>
          <div
            class="lh90 the_registere"
            style="margin-right: 20px"
            @click="getRegisteredLogin(1)"
          >注册</div>
          <div class="lh90 the_login" @click="getRegisteredLogin(2)">登录</div>
        </div>
      </div>
    </div>
    <!-- 服务和置顶 -->
    <!-- <div class="flexClass">
      <p class="uploadImg" v-if="uploadFlag" @click="goModelImage" @mouseover="gotGj('0')" @mouseleave="gotGj('1')"
        data-msg="3D工具" style="z-index: 99;">
        <img style="width:30px;height:30px;margin-top: 10px;" :src="uploadImg" />
      </p>
      <p ref="getGoTopRef" :class="uploadFlag ? 'el-icon-top topClass' : 'el-icon-top topClass1'" @click="getGoTop"
        style="z-index: 99;"></p>
      <p ref="getWeiXin" class="iconfont icon-weixin topClassWeiXin" @mouseover="gotoWeiXin('0')"
        @mouseleave="gotoWeiXin('1')" style="z-index: 99999;">
        <span id="rwm"
          style="width:140px;height:150px;float:left;position:absolute;display: none;border-radius: 5px;margin-left: -180px;margin-top: -90px;background-color: white;padding:10px;box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);">
          <span class="scanCode" style="">扫码联系微信客服</span>
          <img style="width:130px;height:130px;margin-top: -14px;" :src="csCode.value" />
        </span>
      </p>
      <p ref="gettopCharts" class="topCharts" @click="startChat" data-msg="聊天消息" style="z-index: 99;">
        <el-badge :value="this.$store.state.unReadMsgCount" class="item" :hidden="!this.$store.state.unReadMsgCount > 0">
          <i class="el-icon-chat-dot-square"></i>
        </el-badge>
      </p>
      <p ref="getGoConsult" class=" topClassCheck" @click="onlineConsult" data-msg="咨询留言" style="z-index: 99;">
        <i class="el-icon-service"></i>
      </p>
      <el-dropdown style="z-index: 99;" v-if="shareFlag" @visible-change="gotShare" class="shareImg" :hide-on-click="true"
        placement="left">
        <span class="el-dropdown-link" style="display: inline-block;height: 100%;width: 100%;">
          <i class="iconfont icon-fenxiang-copy" style="font-size: 27px;"></i>
        </span>
        <template #dropdown>
          <el-dropdown-menu>
            <el-dropdown-item command="a">
              <div @click="copyLink" style="vertical-align: middle;">
                <i class="el-icon-link"></i>
                复制链接
              </div>
            </el-dropdown-item>
            <el-dropdown-item command="b">
              <div @click="share_weibo($event)">
                <img src="../../assets/xl.png" style="width:20px;height:20px;margin-right: 5px;vertical-align: middle;" />
                <span>新浪微博</span>
              </div>
            </el-dropdown-item>
            <el-dropdown-item command="c" disabled>
              <div>
                <img src="../../assets/wechat2.png"
                  style="width:20px;height:20px;margin-right: 5px;vertical-align: middle;" />
                微信扫一扫
              </div>
              <div id="qrcode" ref="qrcode"></div>
            </el-dropdown-item>
          </el-dropdown-menu>
        </template>
      </el-dropdown>
    </div>-->
    <!-- 用户弹窗 -->
    <div v-show="uesermess" @click="closeMsg" class="userMessageBox">
      <div class="userMessage flex">
        <img
          v-if="$store.state.isUsermessage.headUrl == null"
          src="../../assets/users.png"
          alt
          @click="goToUserCenter"
        />
        <img
          v-if="$store.state.isUsermessage.headUrl != null"
          :src="$store.state.isUsermessage.headUrl"
          alt
          @click="goToUserCenter"
        />
        <div class="userMes">
          <h4 @click="goToUserCenter">{{ $store.state.isUsermessage.name }}</h4>
          <div class="userMesBox flex">
            <div class="userMesNames flex">
              <!-- <p>游客</p> -->
              <p v-if="$store.state.isUsermessage.identity == 'ENTERPRISE'">企业认证</p>
              <p v-if="$store.state.isUsermessage.identity == 'STAFF'">企业成员</p>
              <p v-if="$store.state.isUsermessage.identity == 'PERSONAL'">个人实名认证</p>
              <p v-if="$store.state.isUsermessage.identity == 'ANONYMOUS'">游客</p>
              <!-- <p>企业认证</p> -->
            </div>
            <p class="noUser" @click="getNoUser">退出登录</p>
          </div>
        </div>
      </div>
    </div>
    <!-- 工作台弹窗 -->
    <div
      v-show="showTimes"
      @mouseenter="showTimesMessage"
      @mouseleave="falseTimesMessage"
      class="worksDi"
      ref="showTimesRef"
    >
      <div class="loginMess" :style="{ right: userNameWidth }">
        <!-- 解决跨域通信 -->
        <!-- <p class="usercenter" @click="getUsercenter('buyer')">买家工作台</p>
        <p class="usercenter" @click="getUsercenter('seller')" v-if="seller">
          卖家工作台
        </p>
        <p class="usercenter" @click="getUsercenter('designer')" v-if="designer">
          设计师工作台
        </p>-->
        <p class="usercenter" @click="getUsercenter('leader')">个人工作台</p>
        <p class="usercenter" @click="goCloud()">上云填报</p>
        <p class="usercenter" @click="goDeclare()">项目申报</p>
      </div>
    </div>
    <!-- 搜索弹框 -->
    <div class="searchDialog" v-show="searchShow" @click="closeSearchShow">
      <div class="right_input" :style="{ right: searchDialogWidth }">
        <el-input placeholder="请输入搜索内容" suffix-icon="el-icon-search" v-model="input1"></el-input>
      </div>
    </div>

    <!--聊天窗口-->
    <chat-dialog ref="chatDialogRef"></chat-dialog>
    <div style="height: 80px" v-if="!napColorShow"></div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import {
  getNewcurrent,
  getNapList,
  getBannerInfo
} from "../../utils/interface";
import solutionNavigation from "./solutionNavigation";
import mapMesgList from "./mapMesgList";
import * as RongIMLib from "@rongcloud/imlib-next";

import chatDialog from "../chat/chatDialog";
import QRCode from "qrcodejs2";

export default {
  components: {
    solutionNavigation,
    chatDialog,
    mapMesgList
  },
  data() {
    return {
      // nap
      flag: false,
      uploadImg: require("../../assets/gj.png"),
      // shareImg: require('../../assets/share1.png'),
      uploadFlag: false,
      shareFlag: false,
      maplist: [],
      mapLi: "首页",
      cemera: true,
      setIn: null, // 定时器
      userName: "",
      input1: "",
      csCode: "",
      searchShow: false,
      isSolution: false,
      showTimes: false,
      uesermess: false,
      seller: false,
      designer: false,
      judger: false,
      userNameWidth: "0px",
      searchDialogWidth: "0px",
      setInTime: null,
      setInTime2: null,
      // share_con: false,
      infoContinue: false, //增加
      napColorShow: false,
      searchText: "", //搜索信息
      ifTop: true, // 是否是顶部
      currentRoute: "", // 当前路由
      searchTypeList: [
        {
          value: "1",
          label: "资讯信息"
        },
        {
          value: "2",
          label: "专家库"
        },
        {
          value: "3",
          label: "服务商"
        },
        {
          value: "4",
          label: "解决方案"
        },
        {
          value: "5",
          label: "典型案例"
        },
        {
          value: "6",
          label: "精品课程"
        }
      ], // 搜索类型list
      selectType: "1" // 选择类型
    };
  },
  created() {
    // this.editNapColor();
    this.setIn = setInterval(() => {
      if (this.isTokenDoor === true) {
        clearInterval(this.setIn);
        this.getCsCode();
        this.getMenuList();
        this.getUserMessage();
      }
    }, 500);
    // console.log(333333, this.$route.name == "printServiceIndex");
    setTimeout(() => {
      if (location.href.indexOf("activeDetail") !== -1) {
        this.shareFlag = true;
        this.mapLi = "设计市场";
      } else if (
        location.href.indexOf("design") !== -1 ||
        location.href.indexOf("designModel") !== -1 ||
        location.href.indexOf("designDetails") !== -1 ||
        location.href.indexOf("designList") !== -1 ||
        location.href.indexOf("designerList") !== -1 ||
        location.href.indexOf("designRelease") !== -1 ||
        location.href.indexOf("activeList") !== -1 ||
        location.href.indexOf("activeDetail") !== -1 ||
        location.href.indexOf("worksDetails") !== -1 ||
        location.href.indexOf("winDetails") !== -1 ||
        location.href.indexOf("leaderList") !== -1 ||
        location.href.indexOf("productWork") !== -1
      ) {
        this.mapLi = "设计市场";
      } else if (
        location.href.indexOf("model") !== -1 ||
        location.href.indexOf("modelDetails") !== -1 ||
        location.href.indexOf("threeDModel") !== -1
      ) {
        this.mapLi = "3D模型库";
        this.uploadFlag = true;
      } else if (
        location.href.indexOf("mall") !== -1 ||
        location.href.indexOf("shopGoodsList") !== -1 ||
        location.href.indexOf("shopMallList") !== -1 ||
        location.href.indexOf("shopGoodDetails") !== -1 ||
        location.href.indexOf("shopServiceAuthentication") !== -1 ||
        location.href.indexOf("shopAffirmOrder") !== -1 ||
        location.href.indexOf("shopCar") !== -1 ||
        location.href.indexOf("MallList") !== -1 ||
        location.href.indexOf("integralActivities") !== -1 ||
        location.href.indexOf("activeShopGoodDetails") !== -1 ||
        location.href.indexOf("activeShopAffirmOrder") !== -1 ||
        location.href.indexOf("activeShopSendSuccess") !== -1 ||
        location.href.indexOf("collectActivities") !== -1 ||
        location.href.indexOf("collectShopGoodDetails") !== -1 ||
        location.href.indexOf("collectShopAffirmOrder") !== -1 ||
        location.href.indexOf("collectShopSendSuccess") !== -1 ||
        location.href.indexOf("supplyHome") !== -1 ||
        location.href.indexOf("demandList") !== -1 ||
        location.href.indexOf("demandDetails") !== -1 ||
        location.href.indexOf("serviceList") !== -1 ||
        location.href.indexOf("serviceDetails") !== -1 ||
        location.href.indexOf("lineDetails") !== -1 ||
        location.href.indexOf("offlineList") !== -1 ||
        location.href.indexOf("qualityServiceProviderList") !== -1 ||
        this.$route.name == "printServiceIndex" ||
        location.href.indexOf("enter") !== -1 ||
        this.$route.query.type == "buttJoint" ||
        location.href.indexOf("productHome") !== -1 ||
        location.href.indexOf("productList") !== -1 ||
        location.href.indexOf("productDetails") !== -1 ||
        location.href.indexOf("seriesDetails") !== -1 ||
        location.href.indexOf("productCompare") !== -1 ||
        location.href.indexOf("specList") !== -1 ||
        location.href.indexOf("newSpecList") !== -1 ||
        location.href.indexOf("specOrderCar") !== -1 ||
        location.href.indexOf("productOrderPage") !== -1
      ) {
        this.mapLi = "产业协同";
        console.log("location.href", location.href, this.mapLi);
      } else if (location.href.indexOf("strategy") !== -1) {
        this.mapLi = "3D课堂";
      } else if (
        location.href.indexOf("apps") !== -1 ||
        location.href.indexOf("saasDetails") !== -1 ||
        location.href.indexOf("saasList") !== -1
      ) {
        this.mapLi = "软件超市";
      } else if (location.href.indexOf("businessSearch") !== -1) {
        this.mapLi = "商机线索";
      } else if (
        location.href.indexOf("innovateService") !== -1 ||
        location.href.indexOf("innovateDetail") !== -1 ||
        location.href.indexOf("projectApply") !== -1 ||
        location.href.indexOf("projectReport") !== -1 ||
        location.href.indexOf("elegantList") !== -1 || 
        location.href.indexOf("elegantDetail") !== -1 
      ) {
        this.mapLi = "创新服务";
      } else if (
        location.href.indexOf("talentService") !== -1 ||
        location.href.indexOf("payEnterance") !== -1 ||
        location.href.indexOf("liveOpenList") !== -1 ||
        location.href.indexOf("liveOpenDetail") !== -1 ||
        location.href.indexOf("onlineCourseList") !== -1 ||
        location.href.indexOf("onlineCourseDetail") !== -1 ||
        location.href.indexOf("onlineCourseVideo") !== -1 ||
        location.href.indexOf("trainingCourseList") !== -1
      ) {
        this.mapLi = "人才服务";
      } else if (
        location.href.indexOf("businessDiagnosis") !== -1 ||
        location.href.indexOf("diagnosisDetail") !== -1 ||
        location.href.indexOf("diagnosisVLList") !== -1 ||
        location.href.indexOf("cloudUp") !== -1 ||
        location.href.indexOf("fillStep") !== -1
      ) {
        this.mapLi = "企业诊断";
      } else if (
        location.href.indexOf("resourcePool") !== -1 ||
        location.href.indexOf("expertDetail") !== -1 ||
        location.href.indexOf("providerList") !== -1 ||
        location.href.indexOf("providerDetail") !== -1
      ) {
        this.mapLi = "资源池";
      } else if (
        location.href.indexOf("digitalize") !== -1 ||
        location.href.indexOf("digServiceList") !== -1 ||
        location.href.indexOf("digServiceDetail") !== -1
      ) {
        this.mapLi = "数字化服务";
      } else if (location.href.indexOf("newsConsult") !== -1) {
        this.mapLi = "新闻咨询";
      } else if (location.href.indexOf("gov") !== -1) {
        this.mapLi = "政务信息";
      } else if (location.href.indexOf("reverso") !== -1) {
        this.mapLi = "赋码追溯";
      } else if (location.href.indexOf("model") !== -1) {
        this.mapLi = "远程思维";
      } else if (location.href.indexOf("solution") !== -1) {
        // else if (location.href.indexOf("join") !== -1)
        this.mapLi = "解决方案";
      } else if (
        location.href.indexOf("association") !== -1 ||
        location.href.indexOf("introduction") !== -1 ||
        location.href.indexOf("member") !== -1 ||
        location.href.indexOf("dynamicState") !== -1
      ) {
        this.mapLi = "水泵协会";
      } else if (
        location.href.indexOf("park") !== -1 ||
        location.href.indexOf("allPark") !== -1 ||
        location.href.indexOf("parkDetails") !== -1 ||
        location.href.indexOf("parkDynamic") !== -1 ||
        location.href.indexOf("centerDetails") !== -1
      ) {
        this.mapLi = "泵都风采";
      } else if (
        location.href.indexOf("homeLiveList") !== -1 ||
        location.href.indexOf("homeLiveDetail") !== -1 ||
        location.href.indexOf("serviceCenter") !== -1 ||
        location.href.indexOf("caseDetail") !== -1 ||
        location.href.indexOf("caseList") !== -1
      ) {
        this.mapLi = "首页";
      } else {
        this.mapLi = "首页";
      }
    }, 500);
    console.log("this.mapLi", this.mapLi);
  },
  mounted() {
    this.currentRoute = window.location.pathname;
    window.addEventListener("scroll", this.menu);
    if (location.pathname == "/newsConsult") {
      this.searchText = this.$store.state.searchMsg;
      this.$refs.allSearch.focus();
    } else if (location.pathname == "/onlineCourseList") {
      this.searchText = this.$store.state.searchMsg;
      this.selectType = this.$store.state.searchType;
      this.$refs.allSearch.focus();
    }
  },
  computed: {
    ...mapState({
      routerPath: "routerPath",
      isTokenDoor: "isTokenDoor",
      isLogin: "isLogin",
      isUsermessage: "isUsermessage",
      share_con: "share_con",
      searchMsg: "searchMsg"
    })
  },
  watch: {
    routerPath(newVal, oldNew) {
      if (newVal.indexOf("activeDetail") !== -1) {
        this.shareFlag = true;
      } else if (
        newVal.indexOf("design") !== -1 ||
        newVal.indexOf("designModel") !== -1 ||
        newVal.indexOf("designDetails") !== -1 ||
        newVal.indexOf("designList") !== -1 ||
        newVal.indexOf("designerList") !== -1 ||
        newVal.indexOf("designRelease") !== -1 ||
        newVal.indexOf("activeList") !== -1 ||
        newVal.indexOf("activeDetail") !== -1 ||
        newVal.indexOf("worksDetails") !== -1 ||
        newVal.indexOf("winDetails") !== -1 ||
        newVal.indexOf("leaderList") !== -1
      ) {
        this.mapLi = "设计市场";
      } else if (
        newVal.indexOf("model") !== -1 ||
        newVal.indexOf("modelDetails") !== -1 ||
        newVal.indexOf("threeDModel") !== -1
      ) {
        this.mapLi = "3D模型库";
        this.uploadFlag = true;
      } else if (
        newVal.indexOf("mall") !== -1 ||
        newVal.indexOf("shopGoodsList") !== -1 ||
        newVal.indexOf("shopMallList") !== -1 ||
        newVal.indexOf("shopGoodDetails") !== -1 ||
        newVal.indexOf("shopServiceAuthentication") !== -1 ||
        newVal.indexOf("shopAffirmOrder") !== -1 ||
        newVal.indexOf("shopCar") !== -1 ||
        newVal.indexOf("integralActivities") !== -1 ||
        newVal.indexOf("activeShopGoodDetails") !== -1 ||
        newVal.indexOf("activeShopAffirmOrder") !== -1 ||
        newVal.indexOf("activeShopSendSuccess") !== -1 ||
        newVal.indexOf("collectActivities") !== -1 ||
        newVal.indexOf("collectShopGoodDetails") !== -1 ||
        newVal.indexOf("collectShopAffirmOrder") !== -1 ||
        newVal.indexOf("collectShopSendSuccess") !== -1 ||
        newVal.indexOf("demandList") !== -1 ||
        newVal.indexOf("demandDetails") !== -1 ||
        newVal.indexOf("serviceList") !== -1 ||
        newVal.indexOf("serviceDetails") !== -1 ||
        newVal.indexOf("lineDetails") !== -1 ||
        newVal.indexOf("offlineList") !== -1 ||
        newVal.indexOf("qualityServiceProviderList") !== -1 ||
        newVal.indexOf("printServiceIndex") !== -1 ||
        newVal.indexOf("enter") !== -1 ||
        newVal.indexOf("productHome") !== -1 ||
        newVal.indexOf("productList") !== -1 ||
        newVal.indexOf("productDetails") !== -1 ||
        newVal.indexOf("seriesDetails") !== -1 ||
        newVal.indexOf("productCompare") !== -1 ||
        newVal.indexOf("specList") !== -1 ||
        newVal.indexOf("newSpecList") !== -1 ||
        newVal.indexOf("specOrderCar") !== -1 ||
        newVal.indexOf("productOrderPage") !== -1
      ) {
        this.mapLi = "产业协同";
      } else if (newVal.indexOf("strategy") !== -1) {
        this.mapLi = "3D课堂";
      } else if (
        newVal.indexOf("apps") !== -1 ||
        newVal.indexOf("saasDetails") !== -1 ||
        newVal.indexOf("saasList") !== -1
      ) {
        this.mapLi = "软件超市";
      } else if (newVal.indexOf("businessSearch") !== -1) {
        this.mapLi = "商机线索";
      } else if (
        newVal.indexOf("innovateService") !== -1 ||
        newVal.indexOf("innovateDetail") !== -1 ||
        newVal.indexOf("projectApply") !== -1 ||
        newVal.indexOf("projectReport") !== -1 ||
        newVal.indexOf("elegantList") !== -1 ||
        newVal.indexOf("elegantDetail") !== -1 
      ) {
        this.mapLi = "创新服务";
      } else if (
        newVal.indexOf("talentService") !== -1 ||
        newVal.indexOf("payEnterance") !== -1 ||
        newVal.indexOf("liveOpenList") !== -1 ||
        newVal.indexOf("liveOpenDetail") !== -1
      ) {
        this.mapLi = "人才服务";
      } else if (
        newVal.indexOf("businessDiagnosis") !== -1 ||
        newVal.indexOf("diagnosisDetail") !== -1 ||
        newVal.indexOf("diagnosisVLList") !== -1 ||
        newVal.indexOf("cloudUp") !== -1 ||
        newVal.indexOf("fillStep") !== -1
      ) {
        this.mapLi = "企业诊断";
      } else if (
        newVal.indexOf("resourcePool") !== -1 ||
        newVal.indexOf("expertDetail") !== -1
      ) {
        this.mapLi = "资源池";
      } else if (
        newVal.indexOf("digitalize") !== -1 ||
        newVal.indexOf("digServiceList") !== -1 ||
        newVal.indexOf("digServiceDetail") !== -1
      ) {
        this.mapLi = "数字化服务";
      } else if (newVal.indexOf("newsConsult") !== -1) {
        this.mapLi = "新闻咨询";
      } else if (newVal.indexOf("gov") !== -1) {
        this.mapLi = "政务信息";
      } else if (newVal.indexOf("reverso") !== -1) {
        this.mapLi = "赋码追溯";
      } else if (newVal.indexOf("offline") !== -1) {
        this.mapLi = "远程思维";
      } else if (newVal.indexOf("solution") !== -1) {
        this.mapLi = "解决方案";
      } else if (
        newVal.indexOf("park") !== -1 ||
        newVal.indexOf("allPark") !== -1 ||
        newVal.indexOf("parkDetails") !== -1 ||
        newVal.indexOf("parkDynamic") !== -1 ||
        newVal.indexOf("centerDetails") !== -1
      ) {
        this.mapLi = "泵都风采";
      } else if (
        newVal.indexOf("association") !== -1 ||
        newVal.indexOf("introduction") !== -1 ||
        newVal.indexOf("member") !== -1 ||
        newVal.indexOf("dynamicState") !== -1
      ) {
        this.mapLi = "水泵协会";
      } else if (
        newVal.indexOf("") !== -1 ||
        newVal.indexOf("homeLiveList") !== -1 ||
        newVal.indexOf("homeLiveDetail") !== -1 ||
        newVal.indexOf("serviceCenter") !== -1 ||
        newVal.indexOf("caseDetail") !== -1 ||
        newVal.indexOf("caseList") !== -1
      ) {
        this.mapLi = "首页";
      } else {
        this.mapLi = "首页";
      }
      // if (
      //   newVal === "/news" ||
      //   newVal === "/solution" ||
      //   newVal === "/" ||
      //   newVal === "/park" ||
      //   newVal === "/cases" ||
      //   newVal === "/parkDynamic" ||
      //   newVal === "/association" ||
      //   newVal === "/mall" ||
      //   newVal === "/apps" ||
      //   newVal.indexOf("/centerDetails") !== -1
      // ) {
      //   this.napColorShow = true;
      // } else {
      //   this.napColorShow = false;
      // }
    },
    searchMsg(val) {
      this.searchText = val;
      if (this.selectType == "1" || this.selectType == "6") {
        this.searchMsgVuex(val);
      }
    }
  },
  methods: {
    changeBg() {
      let topNav = document.getElementById("topNav");
      let length1 = document.querySelectorAll(".changeColor").length;
      let length2 = document.querySelectorAll(".el-dropdown").length;
      // let input = document.querySelector(".el-input-group")
      let staging1 = document.getElementById("staging1");
      let staging2 = document.getElementById("staging2");
      let user = document.getElementById("user");
      if (
        this.currentRoute == "/liveOpenList" ||
        this.currentRoute == "/onlineCourseList" ||
        this.currentRoute.indexOf("/news/newDetails") !== -1 ||
        this.currentRoute.indexOf("/expertDetail") !== -1 ||
        this.currentRoute.indexOf("/liveOpenDetail") !== -1 ||
        this.currentRoute.indexOf("/onlineCourseDetail") !== -1 ||
        this.currentRoute.indexOf("/innovateDetail") !== -1 ||
        this.currentRoute.indexOf("/elegantList") !== -1 ||
        this.currentRoute.indexOf("/diagnosisDetail") !== -1 ||
        this.currentRoute.indexOf("/userCenter") !== -1 ||
        this.currentRoute.indexOf("/payEnterance") !== -1 ||
        this.currentRoute.indexOf("/homeLiveList") !== -1 ||
        this.currentRoute.indexOf("/diagnosisVLList") !== -1 ||
        this.currentRoute.indexOf("/homeLiveDetail") !== -1 ||
        this.currentRoute.indexOf("/projectReport") !== -1 ||
        this.currentRoute.indexOf("/projectApply") !== -1 ||
        this.currentRoute.indexOf("/fillStep") !== -1 ||
        this.currentRoute.indexOf("/activeList") !== -1 ||
        this.currentRoute.indexOf("/activeDetail") !== -1 ||
        this.currentRoute.indexOf("/worksDetails") !== -1 ||
        this.currentRoute.indexOf("/helpCenterDetail") !== -1
      ) {
        this.ifTop = false;
        topNav.style.backgroundColor = "#fff";
        if (staging1) {
          staging1.style.color = "#000";
        }
        if (staging2) {
          staging2.style.color = "#000";
        }
        if (user) {
          user.style.color = "#000";
        }
        for (let i = 0; i < length1; i++) {
          document.querySelectorAll(".changeColor")[i].style.color = "#000";
        }
        for (let i = 0; i < length2; i++) {
          document.querySelectorAll(".el-dropdown")[i].style.color = "#000";
        }
        // input.style.border = "1px solid #000"
        // input.style.borderRadius = "19px"
      } else {
        this.ifTop = true;
        // 修改顶部nav的背景色
        topNav.style.backgroundColor = "rgba(0, 0, 0, 0.2)";
      }
    },
    // 页面滚动
    menu() {
      let scroll =
        document.documentElement.scrollTop || document.body.scrollTop;
      // console.log('scroll  ' + scroll)
      let topNav = document.getElementById("topNav");
      let length1 = document.querySelectorAll(".changeColor").length;
      let length2 = document.querySelectorAll(".el-dropdown").length;
      // let input = document.querySelector(".el-input-group")
      let staging1 = document.getElementById("staging1");
      let staging2 = document.getElementById("staging2");
      let user = document.getElementById("user");
      // console.log('staging1', staging1, 'staging2', staging2, 'user', user)
      if (
        scroll < 10 &&
        this.currentRoute !== "/liveOpenList" &&
        this.currentRoute !== "/onlineCourseList" &&
        this.currentRoute.indexOf("/news/newDetails") == -1 &&
        this.currentRoute.indexOf("/expertDetail") == -1 &&
        this.currentRoute.indexOf("/liveOpenDetail") == -1 &&
        this.currentRoute.indexOf("/onlineCourseDetail") == -1 &&
        this.currentRoute.indexOf("/innovateDetail") == -1 &&
        this.currentRoute.indexOf("/elegantList") == -1 &&
        this.currentRoute.indexOf("/diagnosisDetail") == -1 &&
        this.currentRoute.indexOf("/userCenter") == -1 &&
        this.currentRoute.indexOf("/payEnterance") == -1 &&
        this.currentRoute.indexOf("/homeLiveList") == -1 &&
        this.currentRoute.indexOf("/diagnosisVLList") == -1 &&
        this.currentRoute.indexOf("/homeLiveDetail") == -1 &&
        this.currentRoute.indexOf("/projectReport") == -1 &&
        this.currentRoute.indexOf("/projectApply") == -1 &&
        this.currentRoute.indexOf("/fillStep") == -1 &&
        this.currentRoute.indexOf("/activeList") == -1 &&
        this.currentRoute.indexOf("/activeDetail") == -1 &&
        this.currentRoute.indexOf("/worksDetails") == -1 &&
        this.currentRoute.indexOf("/helpCenterDetail") == -1
      ) {
        this.ifTop = true;
        // 修改顶部nav的背景色
        topNav.style.backgroundColor = "rgba(0, 0, 0, 0.2)";
        if (staging1) {
          staging1.style.color = "#fff";
        }
        if (staging2) {
          staging2.style.color = "#fff";
        }
        if (user) {
          user.style.color = "#fff";
        }
        // 修改颜色
        for (let i = 0; i < length1; i++) {
          document.querySelectorAll(".changeColor")[i].style.color = "#fff";
        }
        // 修改带下拉框的颜色
        for (let i = 0; i < length2; i++) {
          document.querySelectorAll(".el-dropdown")[i].style.color = "#fff";
        }
        // input.style.border = "none"
      } else {
        this.ifTop = false;
        topNav.style.backgroundColor = "#fff";
        if (staging1) {
          staging1.style.color = "#000";
        }
        if (staging2) {
          staging2.style.color = "#000";
        }
        if (user) {
          user.style.color = "#000";
        }
        for (let i = 0; i < length1; i++) {
          document.querySelectorAll(".changeColor")[i].style.color = "#000";
        }
        for (let i = 0; i < length2; i++) {
          document.querySelectorAll(".el-dropdown")[i].style.color = "#000";
        }
        // input.style.border = "1px solid #000"
        // input.style.borderRadius = "19px"
      }
    },
    ...mapMutations([
      "isLoginVuex",
      "isStorageUsermessage",
      "cleanUsermessage",
      "isShare_con",
      "searchMsgVuex",
      "searchTypeVuex"
    ]),
    // 判断路由的从而更待nap的颜色
    editNapColor() {
      if (
        this.routerPath === "/news" ||
        this.routerPath === "/solution" ||
        this.routerPath === "/" ||
        this.routerPath === "/park" ||
        this.routerPath === "/cases" ||
        this.routerPath === "/parkDynamic" ||
        this.routerPath === "/association" ||
        this.routerPath === "/mall" ||
        this.routerPath === "/apps" ||
        this.routerPath.indexOf("/centerDetails") !== -1
      ) {
        this.napColorShow = true;
      } else {
        this.napColorShow = false;
      }
    },
    /* 全局查询 */
    overRallQuery() {
      if (this.searchText) {
        if (this.selectType == "1" || this.selectType == "6") {
          // 把搜索条件保存在store
          this.searchMsgVuex(this.searchText);
          if (this.selectType == "6") {
            this.searchTypeVuex(this.selectType);
          }
        } else {
          // 其他页面进去之后不保留查询条件,默认type为 1
          this.searchMsgVuex("");
          this.searchTypeVuex("1");
        }
        switch (this.selectType) {
          case "1":
            // 如果当前页面是资讯信息页面，则不开新页面
            if (location.pathname == "/newsConsult") {
              this.$router.push({
                path: "/newsConsult",
                query: {
                  title: this.searchText
                }
              });
            } else {
              window.open(this.getRoute("newsConsult").href, "_blank");
            }
            break;
          case "2":
            window.open(this.getRoute("resourcePool").href, "_blank");
            break;
          case "3":
            window.open(this.getRoute("providerList").href, "_blank");
            break;
          case "4":
            window.open(this.getRoute("digServiceList").href, "_blank");
            break;
          case "5":
            window.open(this.getRoute("caseList").href, "_blank");
            break;
          case "6":
            if (location.pathname == "/onlineCourseList") {
              this.$router.push({
                path: "/onlineCourseList",
                query: {
                  title: this.searchText
                }
              });
            } else {
              window.open(this.getRoute("onlineCourseList").href, "_blank");
            }
            break;
          default:
            break;
        }
      }
    },
    /* 获取路由 */
    getRoute(routeName) {
      let routeData = this.$router.resolve({
        path: `/${routeName}`,
        query: {
          title: this.searchText
        }
      });
      return routeData;
    },
    getCsCode() {
      getBannerInfo("csCode")
        .then(response => {
          this.csCode = response;
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    // 回到顶端
    getGoTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    },
    // 进入在线咨询
    onlineConsult() {
      let newToken = this.$cookies.get("api_token_new");
      if (newToken) {
        this.$router.push("/onlineConsult");
      } else {
        this.$router.push("/login");
      }
    },

    //微信二维码
    gotoWeiXin(str) {
      let rwm = document.getElementById("rwm");
      if (str == "0") {
        rwm.style.display = "block";
      } else {
        rwm.style.display = "none";
      }
    },
    //模型
    gotGj(str) {
      if (str == "0") {
        this.uploadImg = require("../../assets/gj1.png");
      } else {
        this.uploadImg = require("../../assets/gj.png");
      }
    },
    //分享
    gotShare(blo) {
      console.log(blo);
      if (blo === true) {
        if (this.$refs.qrcode.innerHTML == "") {
          if (this.$route.params.uuid) {
            this.qrcode();
          }
        }
      }
    },
    cl_gotShare() {
      if ((this.infoContinue = true)) {
        this.isShare_con(true);
      } else {
        this.isShare_con(false);
      }
    },
    //微博分享
    share_weibo(event) {
      var _shareUrl = "http://service.weibo.com/share/share.php?";
      _shareUrl += "url=" + encodeURIComponent(window.location.href); //参数url设置分享的内容链接
      //     _shareUrl += '&title=' + encodeURIComponent(this.titleCon) //参数title设置分享的标题
      // 保留当前页面,打开一个非tab页面（按需求来，可以新开标签页，也可以在当前页新开页面）
      window.open(
        _shareUrl,
        "_blank",
        "height=100, width=400",
        "scrollbars=yes,resizable=1,modal=false,alwaysRaised=yes"
      );
    },
    //复制地址
    copyLink() {
      let oInput = document.createElement("input");
      // 	//这边为链接地址this.liveLink='www.baidu.com'
      oInput.value = window.location.href;
      document.body.appendChild(oInput);
      oInput.select();
      document.execCommand("Copy");
      oInput.remove();
      this.$message({
        message: "复制成功",
        type: "success"
      });
    },
    //生成二维码
    qrcode() {
      let link =
        "https://www.shuibengcloud.com/#/pages/business/activities/activitiesDetails?uuid=" +
        this.$route.params.uuid +
        "&state=share";
      // console.log(link);
      let qrcode = new QRCode("qrcode", {
        width: 132,
        height: 132,
        text: link, // 需要二维码跳转的地址
        colorDark: "#000", //前景色
        colorLight: "rgba(0,0,0,0)" //背景色
      });
    },
    // 前往用户中心
    goToUserCenter() {
      if (this.$route.fullPath == "/userCenter/00") {
        location.reload();
      } else {
        window.sessionStorage.setItem("userServeId", "00");
        this.$router.push({ path: "/userCenter/00" });
        this.$router.go(0);
      }
      this.uesermess = false;
    },
    goModelImage() {
      this.$router.push("/modelImage");
    },
    // 注销用户
    getNoUser() {
      this.$cookies.remove("api_access_token");
      this.$cookies.remove("api_token_new");
      this.isLoginVuex(false);

      //断开融云
      RongIMLib.disconnect().then(() => {
        console.log("成功断开");
      });

      this.$router.go();
    },
    getHome() {
      this.$router.push("/");
    },
    getMenuList() {
      // getIndexDictionaryData({
      //   groupCode: "MH_MENU",
      //   current: 1,
      //   pageSize: 15,
      // })
      //   .then((response) => {
      //     if (response.length > 0) {
      //       this.maplist = response;
      //       console.log(111111, response)
      //     }
      //   })
      //   .catch(function (error) {
      //     console.log(error);
      //   });
      getNapList()
        .then(res => {
          if (res.length > 0) {
            this.maplist = res;
            this.$nextTick(() => {
              this.changeBg();
            });
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    // 获取用户信息
    getUserMessage() {
      getNewcurrent()
        .then(res => {
          this.$cookies.set("authoritiesMess", " ");
          if (res.authorities.length !== 0) {
            res.authorities.forEach(items => {
              if (items == "sellerCenterService") {
                this.seller = true;
              } else if (items == "designerCenterService") {
                this.designer = true;
              } else if (items == "reviewCenterService") {
                this.judger = true;
              }
            });
          }
          this.userName = res.name;
          this.isStorageUsermessage(res);
        })
        .catch(err => {
          this.cleanUsermessage(); // 当前未登录
          console.log(err);
        });
    },

    // 首页
    mapNameList(linkUrl, children, titleName) {
      if (titleName === "解决方案") {
        this.$refs.solutionNavigationRef.init(true);
        this.isSolution = true;
      }
      if (children == null) {
        if (linkUrl) {
          window.open(linkUrl, "_blank");
        } else {
          this.$message({
            message: "敬请期待！",
            type: "warning"
          });
        }
      } else {
        if (linkUrl) {
          window.open(linkUrl, "_blank");
        }
      }
    },
    // 进入注册网页/登录网页
    getRegisteredLogin(items) {
      let newToken = this.$cookies.get("api_token_new");
      if (newToken) {
        this.$router.go(0);
      } else {
        if (items == 1) {
          this.$router.push("/registered");
        } else if (items == 2) {
          this.$router.push("/login");
        }
      }
    },
    // 个人中心
    getUsercenter(user) {
      if (user == "seller") {
        let routeData = this.$url.sellerWeb;
        window.open(routeData, "_blank");
        this.$cookies.set("authoritiesMess", "sellerCenterService");
      } else if (user == "buyer") {
        let routeData = this.$url.buyerWeb;
        window.open(routeData, "_blank");
        this.$cookies.set("authoritiesMess", "");
      } else if (user == "designer") {
        let routeData = this.$url.designerWeb;
        window.open(routeData, "_blank");
        this.$cookies.set("authoritiesMess", "designerCenterService");
      } else if (user == "leader") {
        let routeData = this.$url.reviewWeb;
        window.open(routeData, "_blank");
        this.$cookies.set("reviewExamineMess", "reviewCenterService");
        //this.$router.push('/leaderList')
      }
    },
    goCloud() {
      let routeData = this.$url.cloudUrl;
      window.open(routeData, "_blank");
    },
    goDeclare() {
      let routeData = this.$url.declareUrl;
      window.open(routeData, "_blank");
    },
    // 鼠标划入变化颜色
    editColor(type) {
      if (this.napColorShow) {
        if (type == "en") {
          this.$refs.titleRef.src = require("../../assets/logo.png");
        } else {
          this.$refs.titleRef.src = require("../../assets/whiteLogo.png");
        }
      }
    },
    // 鼠标划过解决方案
    solutionMouseOver(name, children) {
      if (children == null) {
        if (name === "解决方案") {
          // this.$refs.solutionNavigationRef.init(true);
          // // this.$refs.getGoTopRef.style.display = "none";
          // // this.$refs.getGoConsult.style.display = "none";
          // // this.$refs.gettopCharts.style.display = "none";
          // this.$refs.navItemRefsolution[0].setAttribute("class", "mapNameLi");
          // this.isSolution = true;
        } else {
          this.$refs.solutionNavigationRef.init(false);
          // this.$refs.getGoTopRef.style.display = "block";
          // this.$refs.getGoConsult.style.display = "block";
          // this.$refs.gettopCharts.style.display = "block";
          this.$refs.navItemRefsolution[0].setAttribute("class", "");
          this.isSolution = false;
        }
      }
    },
    // 关闭解决方案弹出框恢复样式
    closeSolutionNavigation() {
      this.$refs.navItemRefsolution[0].setAttribute("class", "");
      this.$refs.getGoTopRef.style.display = "block";
      this.$refs.getGoConsult.style.display = "block";
      this.$refs.gettopCharts.style.display = "block";
      this.isSolution = false;
    },
    // 用户弹窗
    handleUesermess() {
      this.uesermess = !this.uesermess;
    },
    closeMsg(event) {
      var btn = document.querySelector(".userMessage");
      if (btn) {
        if (!btn.contains(event.target)) {
          this.uesermess = false;
        }
      }
    },
    // 工作台弹窗
    showTimesMessage() {
      this.userNameWidth = this.$refs.userName.offsetWidth + "px";
      // this.userNameWidth = "220px"
      clearInterval(this.setInTime);
      this.showTimes = true;
    },
    falseTimesMessage() {
      this.setInTime = setInterval(() => {
        clearInterval(this.setInTime);
        this.showTimes = false;
      }, 200);
    },
    // 文档页面
    handleDocument() {
      this.$router.push("/helpCenter");
    },
    // 搜索弹窗
    closeSearchShow(event) {
      var btn = document.querySelector(".right_input");
      // debugger;
      if (btn) {
        if (!btn.contains(event.target)) {
          this.searchShow = false;
        }
      }
    },
    searchShowMessage() {
      this.searchDialogWidth = this.$refs.userName.offsetWidth + 240 + "px";
      this.searchShow = !this.searchShow;
    },

    startChat() {
      getNewcurrent()
        .then(res => {
          let newToken = this.$cookies.get("api_token_new");
          if (newToken) {
            this.isStorageUsermessage(res);
            let user = this.$store.state.isUsermessage;
            this.$refs.chatDialogRef.initReply(
              user.uuid,
              user.name,
              user.headUrl
            );
          } else {
            this.$router.push("/login");
          }
        })
        .catch(err => {
          console.log(err);
        });
    }
  }
};
</script>
<style>
.all_select_popper {
  z-index: 99999 !important;
}
</style>
<style scoped lang="less">
.navContentClass {
  box-sizing: border-box;
}

.mapName {
  justify-content: space-between;
  height: 100%;
  margin: 0 20px;
  // margin: 0 auto;

  ul {
    margin: 0;
  }
}

.top-search {
  width: 300px;
  height: 33px;
  border-radius: 16px;
  margin-right: 20px;
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
  flex-shrink: 0;
  .top-search-icon {
    width: 20px;
    height: 27px;
    background: url("../../assets/publicService/search.png") no-repeat center
      center/18px 18px;
  }

  .top-search-list {
    width: 31px;
    height: 21px;
    margin-left: 20px;
    background: url("../../assets/publicService/list.png") no-repeat center
      center/18px 18px;
    cursor: pointer;
  }

  .search-list-black {
    background: url("../../assets/publicService/listb.png") no-repeat center
      center/18px 18px;
  }
}

.loginul {
  line-height: 88px;
  padding-right: 50px;
}

.loginul a {
  color: #d01919;
  font-size: 14px;
}

.mapName .li {
  color: rgba(255, 255, 255, 0.7);
  font-size: 16px;
  line-height: 80px;
}

.mapName .mapNameLi {
  box-shadow: 0 -3px 0 #2d50a1 inset;
  color: #fff !important;
  line-height: 80px;
  font-size: 18px;
  font-weight: 600;
}

.mapName li:hover {
  transition: 0.5s;
  box-shadow: 0 -3px 0 #2d50a1 inset;
  cursor: pointer;
  line-height: 80px;
}

.tittle {
  position: fixed;
  // background: rgba(168, 168, 168, 0.388);
  background-color: rgba(0, 0, 0, 0.8);
  box-shadow: 0 -1px 0 #f0f0f0 inset;
  width: 100%;
  height: 80px;
  z-index: 4000;
  display: flex;
  justify-content: space-between;
  // padding-left: 265px;
  align-items: center;

  &:hover {
    box-shadow: none;
    color: #fff;

    .loginText {
      // color: #000;
    }
  }

  .tittle_ul {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 16px;

    li {
      color: #000;
      width: 100px;
      text-align: center;
    }

    .el-dropdown {
      font-size: 16px;
    }
  }
}

.tittle_other_2 {
  box-shadow: none;
  background: #fff !important;

  li {
    color: #666;
  }

  /deep/.el-dropdown {
    color: #666;
  }

  .loginText {
    color: #666;
  }

  .tittle_ul {
    li {
      color: #666 !important;
    }

    /deep/.el-dropdown {
      color: #666 !important;
    }
  }
}

.tittle_other {
  box-shadow: none;
  background: rgba(0, 0, 0, 0);

  &:hover {
    .tittle_ul {
      li {
        // color: #666;
        color: #fff;
      }

      /deep/.el-dropdown {
        // color: #666;
      }

      .mapNameLi {
        color: #fff !important;
      }
    }
  }

  .tittle_ul {
    li {
      color: #fff;
    }

    /deep/.el-dropdown {
      color: #fff;
    }
  }
}

.tittle .logo {
  align-items: center;
  justify-content: center;
  display: flex;

  img {
    height: 50px;
    margin: 8px 0 0 0;
    padding: 0;
  }
}

.login {
  justify-content: center;
  align-items: center;
  font-size: 13px;

  .the_login {
    font-size: 14px;
    color: #fff;
    padding: 5px 30px;
    background: #2d50a1;
    border-radius: 3px;
    border: 1px solid #2d50a1;
  }

  .the_registere {
    font-size: 14px;
    padding: 5px 30px;
    border-radius: 3px;
    color: #2d50a1;
    border: 1px solid #2d50a1;
    background: #fff;
  }

  .lh90 {
    cursor: pointer;
    font-size: 16px;
  }

  .userName {
    cursor: default;
    font-size: 16px;
    width: 210px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .usercenter {
    margin: 0 15px;
    font-size: 16px;
    cursor: pointer;
  }

  .usercenter:hover {
    border-bottom: 1px solid #009999;
    color: #009999;
  }
}

.right_box {
  align-items: center;
  margin-right: 35px;
  // position: absolute;
  right: 0;

  .search {
    position: relative;
    margin-right: 20px;
    text-align: right;

    i:hover {
      color: #009999;
    }
  }

  .loginText {
    position: relative;
    color: #fff;
    width: 320px;

    p {
      cursor: pointer;
      font-size: 16px;
      margin-right: 25px;

      &:hover {
        // color: #009999;
      }
    }
  }

  .loginTextFFF {
    // color: #fff;
  }
}

.worksDi {
  position: relative;
  z-index: 4001;

  .loginMess {
    width: 200px;
    border-radius: 10px;
    background: #fff;
    position: fixed;
    right: 70px;
    top: 70px;
    box-shadow: 0px 3px 6px 2px #c9c9c95c;
    box-sizing: border-box;

    p {
      cursor: pointer;
      padding: 16px;
      margin: 0;
      padding-bottom: 16px;
      border-bottom: 1px solid #efefef;
      animation: text 1s;
      text-align: center;

      &:hover {
        color: #2d50a1;
      }
    }

    p:nth-last-of-type(1) {
      border: none;
    }
  }
}

.flexClass {
  /deep/ .icon-weixin:before {
    content: "\E660";
  }

  /deep/.icon-fenxiang:before {
    content: "\e605";
  }

  .topCharts {
    background: #fff;
    box-shadow: 0px 0px 17px -7px #009999;
    border-radius: 50%;
    width: 50px;
    height: 50px;
    position: fixed;
    right: 23px;
    bottom: 31%;
    text-align: center;
    line-height: 53px;
    font-size: 27px;
    font-weight: 500;
    font-family: "Avenir", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  .topCharts:hover {
    i {
      color: #fff;
    }

    background: #009999;
  }

  .topCharts:hover:before {
    width: 60px;
    height: 20px;
    content: attr(data-msg);
    position: absolute;
    display: block;
    color: #333;
    -webkit-box-shadow: 0 0 5px 1px #a1b9cda6;
    box-shadow: 0 0 5px 1px #a1b9cda6;
    border-radius: 5px;
    font-size: 14px;
    line-height: 20px;
    top: 11px;
    left: -86%;
    padding: 5px 5px;
    -webkit-transform: translateX(-50%);
    -ms-transform: translateX(-50%);
    transform: translateX(-50%);
    background: #fff;
  }

  .topCharts:hover:after {
    content: "";
    width: 10px;
    height: 10px;
    color: #333;
    box-shadow: 0px 0px 0px 0px #a1b9cda6;
    position: absolute;
    top: 21px;
    left: -30%;
    transform: rotate(46deg);
    background: #fff;
    line-height: 14px;
    font-size: 14px;
    border-radius: 0 0px 50% 50%;
  }

  .shareImg {
    background: #fff;
    box-shadow: 0px 0px 17px -7px #009999;
    border-radius: 50%;
    width: 50px;
    height: 50px;
    position: fixed;
    right: 45px;
    bottom: 13%;
    text-align: center;
    line-height: 53px;
    font-size: 27px;
    font-weight: 500;
    font-family: "Avenir", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;

    i {
      color: #000;
    }
  }

  .shareImg:hover {
    background: #009999;

    i {
      color: #fff;
    }
  }

  .hidden_div {
    background: #fff;
    position: fixed;
    right: 120px;
    bottom: 12%;
    font-size: 14px;
    box-shadow: rgb(0 0 0 / 12%) 0px 1px 3px, rgb(0 0 0 / 24%) 0px 1px 2px;
    padding: 15px;
    border-radius: 5px;

    .root {
      width: 0px;
      height: 0px;
      border: 10px solid transparent;
      border-bottom-color: #fff;
      position: absolute;
      right: -20px;
      bottom: 4%;
      transform: rotate(90deg);
    }

    div {
      align-items: center;
      margin-bottom: 10px;
      cursor: pointer;

      i {
        font-size: 20px;
        vertical-align: middle;
        margin-right: 5px;
      }

      img {
        vertical-align: middle;
      }
    }
  }

  .uploadImg {
    background: #fff;
    box-shadow: 0px 0px 17px -7px #009999;
    border-radius: 50%;
    width: 50px;
    height: 50px;
    position: fixed;
    right: 45px;
    bottom: 22%;
    text-align: center;
    line-height: 53px;
    font-size: 27px;
    font-weight: 500;
    font-family: "Avenir", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  .uploadImg:hover {
    background: #009999;
  }

  .uploadImg:hover:before {
    width: 60px;
    height: 20px;
    content: attr(data-msg);
    position: absolute;
    display: block;
    color: #333;
    -webkit-box-shadow: 0 0 5px 1px #a1b9cda6;
    box-shadow: 0 0 5px 1px #a1b9cda6;
    border-radius: 5px;
    font-size: 14px;
    line-height: 20px;
    top: 11px;
    left: -86%;
    padding: 5px 5px;
    -webkit-transform: translateX(-50%);
    -ms-transform: translateX(-50%);
    transform: translateX(-50%);
    background: #fff;
  }

  .uploadImg:hover:after {
    content: "";
    width: 10px;
    height: 10px;
    color: #333;
    box-shadow: 0px 0px 0px 0px #a1b9cda6;
    position: absolute;
    top: 21px;
    left: -30%;
    transform: rotate(46deg);
    background: #fff;
    line-height: 14px;
    font-size: 14px;
    border-radius: 0 0px 50% 50%;
  }

  .topClass {
    background: #fff;
    box-shadow: 0px 0px 17px -7px #009999;
    border-radius: 50%;
    width: 50px;
    height: 50px;
    position: fixed;
    right: 45px;
    bottom: 13%;
    text-align: center;
    line-height: 53px;
    font-size: 27px;
    font-weight: 500;
    font-family: "Avenir", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  .topClass:hover {
    color: #fff;
    background: #009999;
  }

  .topClass1 {
    background: #fff;
    box-shadow: 0px 0px 17px -7px #009999;
    border-radius: 50%;
    width: 50px;
    height: 50px;
    position: fixed;
    right: 23px;
    bottom: 22%;
    text-align: center;
    line-height: 53px;
    font-size: 27px;
    font-weight: 500;
    font-family: "Avenir", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  .topClass1:hover {
    color: #fff;
    background: #009999;
  }

  .topClassCheck {
    background: #fff;
    box-shadow: 0px 0px 17px -7px #009999;
    border-radius: 50%;
    width: 50px;
    height: 50px;
    position: fixed;
    right: 23px;
    bottom: 40%;
    text-align: center;
    line-height: 53px;
    font-size: 27px;
    font-weight: 500;
    font-family: "Avenir", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  .topClassCheck:hover {
    i {
      color: #fff;
    }

    background: #009999;
  }

  .topClassCheck:hover:before {
    width: 60px;
    height: 20px;
    content: attr(data-msg);
    position: absolute;
    display: block;
    color: #333;
    -webkit-box-shadow: 0 0 5px 1px #a1b9cda6;
    box-shadow: 0 0 5px 1px #a1b9cda6;
    border-radius: 5px;
    font-size: 14px;
    line-height: 20px;
    top: 11px;
    left: -86%;
    padding: 5px 5px;
    -webkit-transform: translateX(-50%);
    -ms-transform: translateX(-50%);
    transform: translateX(-50%);
    background: #fff;
  }

  .topClassCheck:hover:after {
    content: "";
    width: 10px;
    height: 10px;
    color: #333;
    box-shadow: 0px 0px 0px 0px #a1b9cda6;
    position: absolute;
    top: 21px;
    left: -30%;
    transform: rotate(46deg);
    background: #fff;
    line-height: 14px;
    font-size: 14px;
    border-radius: 0 0px 50% 50%;
  }

  .topClassWeiXin {
    background: #fff;
    box-shadow: 0px 0px 17px -7px #009999;
    border-radius: 50%;
    width: 50px;
    height: 50px;
    position: fixed;
    /*position:relative;*/
    right: 23px;
    bottom: 49%;
    text-align: center;
    line-height: 53px;
    font-size: 27px;
    font-weight: 500;
    font-family: "Avenir", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  .topClassWeiXin:hover {
    color: #fff;
    background: #009999;
  }
}

.userMessageBox {
  position: fixed;
  width: 100%;
  z-index: 4001;
  height: 100%;
}

.userMessage {
  position: absolute;
  top: 70px;
  // right: 24px;
  right: 104px;
  background: #fff;
  box-shadow: 0px 3px 6px 2px #c9c9c95c;
  box-sizing: border-box;
  border-radius: 10px;
  padding: 20px;

  img {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    margin-right: 16px;
    cursor: pointer;
  }

  .userMes {
    h4 {
      font-size: 13px;
      margin-bottom: 10px;
      cursor: pointer;

      &:hover {
        color: #2d50a1;
      }
    }

    .userMesBox {
      align-items: center;
      white-space: normal;
      justify-content: space-between;

      white-space:nowrap p {
        margin: 0;
        white-space: nowrap;
        font-size: 14px;
      }

      .userMesNames {
        margin-right: 42px;

        p {
          padding: 2px 14px;
          border-radius: 20px;
          cursor: default;
          white-space: nowrap;
          font-size: 12px;
        }

        p:nth-of-type(1) {
          background: #05930a25;
          color: #05930a;
          margin-right: 10px;
        }

        p:nth-of-type(2) {
          background: #a5891748;
          color: #a58917;
          margin-right: 10px;
        }

        p:nth-of-type(3) {
          background: #157dfb45;
          color: #009999;
          margin-right: 10px;
        }
      }
    }
  }

  .noUser {
    cursor: pointer;
    border: none;
    color: #ff9100;
    font-size: 13px;
  }

  .noUser:hover {
    color: #d01919;
  }
}

.searchDialog {
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 9999;

  .right_input {
    position: absolute;
    top: 23px;
    right: 24px;
  }

  /deep/ .el-input__inner {
    border-radius: 40px;
    height: 30px;
    line-height: 30px;
  }

  /deep/ .el-input {
    width: 200px;
    animation: move 1s;
  }

  @keyframes move {
    0% {
      width: 0px;
    }

    100% {
      width: 200px;
    }
  }

  /deep/ .el-input__icon {
    line-height: 30px;
  }
}

.scanCode {
  font-size: 14px;
  display: block;
  margin-top: -17px;
  font-size: 13px;
  color: black;
  font-family: Microsoft YaHei, PingFang SC, Lantinghei SC, Helvetica Neue,
    Helvetica, Arial, \\5fae\8f6f\96c5\9ed1, STHeitiSC-Light, simsun,
    \\5b8b\4f53, WenQuanYi Zen Hei, WenQuanYi Micro Hei, "sans-serif";
}

.scanCode1 {
  font-size: 16px;
  display: block;
  // margin-top: -17px;
  color: black;
  font-family: Microsoft YaHei, PingFang SC, Lantinghei SC, Helvetica Neue,
    Helvetica, Arial, \\5fae\8f6f\96c5\9ed1, STHeitiSC-Light, simsun,
    \\5b8b\4f53, WenQuanYi Zen Hei, WenQuanYi Micro Hei, "sans-serif";
}

.scanCode1:hover {
  color: #009999;
}
/* 搜索下拉框类型选择 */
/deep/ .el-input-group__prepend {
  width: 40px;
  border-top-left-radius: 16px;
  border-bottom-left-radius: 16px;
}
/deep/ .el-select .el-input .el-select__caret {
  width: 20px;
  line-height: 33px;
}
/deep/ .el-input-group__prepend div.el-select .el-input__inner {
  padding: 0 0 0 10px;
}
/deep/ .el-input-group__prepend .el-input {
  min-width: 85px;
}
/deep/ .el-input__suffix {
  right: 0;
}
/* 清除图标 */
/deep/ .el-input .el-input__clear {
  width: 15px;
  line-height: 33px;
}
/* 搜索框样式 */
/deep/ .el-input-group--append .el-input__inner {
  height: 33px;
  padding: 0 18px 0 6px;
  border-top: 1px solid #dcdfe6;
  border-bottom: 1px solid #dcdfe6;
  border-right-color: #dcdfe6;
  border-left-color: #dcdfe6;
  border-right: none;
}
/deep/ .el-input-group {
  // border-top: 1px solid #fff;
  // border-bottom: 1px solid #fff;
  border-radius: 16px;
}
/* 搜索图标样式 */
/deep/ .el-input-group__append {
  padding: 0 4px;
  background-color: #fff;
  border-top-right-radius: 16px;
  border-bottom-right-radius: 16px;
  // border: none;

  &:hover {
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/header/nap.vue